import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_NAME = "Cake World USA";
const SITE_URL = "https://cakeworldusa.com";
const DEFAULT_OG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_bakery-b2b/artifacts/aft2loce_183.jpg";
const DEFAULT_DESC =
  "Cake World USA partners with hotels, restaurants and cafés to deliver a premium wholesale dessert program — 3\" mini and 10\" whole formats, nationwide cold-chain delivery.";

/**
 * <SEO title description image type jsonLd />
 * - title is combined as: "<title> · Cake World USA" (or just SITE_NAME on home)
 * - canonical is derived from the current path against SITE_URL
 */
export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_OG,
  type = "website",
  jsonLd,
}) {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname}`;
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Wholesale desserts for hospitality`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
